import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  partnersPageLink: new analytics.Event({
    name: 'Trusted Partners Page Link Clicked',
    description: 'Merchant clicks link to go to trusted partners page',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
    userAttributes: [],
  }),
};
